import type { FinalResult } from './search-novelty-result-api';

/**
 * 更新查新相似列表请求体
 */
export interface UpdateNoveltySimilarListRequest {
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 查新相似列表
     */
    final_result: UpdateNoveltySimilarFinalResultDto[];
}


export interface UpdateNoveltySimilarFinalResultDto {
    /**
     * 专利ID
     */
    patent_id: string;
    /**
     * 特征
     */
    features: UpdateNoveltySimilarFeatures[];
    /**
     * 是否选中
     */
    selected: boolean;
    /**
     * 是否为最相似
     */
    most_similar: boolean;
}

export interface UpdateNoveltySimilarFeatures {
    /**
     * 对比特征
     */
    comparison_feature: string;
    /**
     * 技术特征
     */
    tech_feature: string;
    /**
     * 是否相似
     */
    similar: boolean;
}

export type UpdateNoveltySimilarListResponse = FinalResult[];

/**
 * 更新查新相似列表请求
 */
export interface FtoReportUpdateSimilarListApi {
    /**
     * 更新查新相似列表
     * @param request 更新查新相似列表请求
     */
    updateNoveltySimilarList(request: UpdateNoveltySimilarListRequest): Promise<UpdateNoveltySimilarListResponse>;
}

export const FtoReportUpdateSimilarListApi = Symbol('FtoReportUpdateSimilarListApi');
